export default "/assets/logo.fe6dc99df411744d4c901a2d97b9fa24.png";